<template>
  <div>
    <el-dialog
      title="生成礼品卡"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="80px"
        v-loading="loading"
      >
        <el-form-item label="卡片主题">
          <el-input v-model="dataForm.topicName" disabled></el-input>
        </el-form-item>
        <el-form-item label="生成数量" prop="quantity">
          <el-input-number
            v-model="dataForm.quantity"
            controls-position="right"
            :min="1"
            placeholder="请输入生成数量"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="dataForm.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <!--二次确认-->
        <el-popconfirm
          title="确认生成礼品卡吗？"
          confirmButtonText="确定"
          cancelButtonText="取消"
          icon="el-icon-question"
          @onConfirm="dataFormSubmit()"
        >
          <el-button type="primary" slot="reference">确定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { giftCardRecordGenerate } from "@/api/giftCard";
export default {
  name: "GiftCardRecordGenerate",
  components: {},
  data() {
    return {
      dialogVisible: false,
      loading: false,
      dataForm: {},
      dataRule: {
        quantity: [
          { required: true, message: "生成数量不能为空", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    open(row) {
      this.dataForm = {
        topicName: row.topicName,
        specId: row.id,
        quantity: 1
      };
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit("close");
      this.dataForm = {};
    },
    dataFormSubmit() {
      console.log(this.dataForm);
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.saveData();
        }
      });
    },
    saveData() {
      this.loading = true;
      const data = this.dataForm;
      giftCardRecordGenerate(data)
        .then(res => {
          if (res.data.status == 100) {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.handleClose();
            this.$emit("refresh");
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// generateCard.vue?468d4af5